"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.timers.js");

var _popup = _interopRequireDefault(require("element-ui/lib/utils/popup"));

var _locale = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var _input = _interopRequireDefault(require("element-ui/lib/input"));

var _button = _interopRequireDefault(require("element-ui/lib/button"));

var _dom = require("element-ui/lib/utils/dom");

var _locale2 = require("element-ui/lib/locale");

var _ariaDialog = _interopRequireDefault(require("element-ui/lib/utils/aria-dialog"));

var _util = require("element-ui/lib/utils/util");

var messageBox;
var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "msgbox-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "el-message-box__wrapper",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.title || 'dialog'
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.handleWrapperClick($event);
      }
    }
  }, [_c('div', {
    staticClass: "el-message-box",
    "class": [_vm.customClass, _vm.center && 'el-message-box--center'],
    attrs: {}
  }, [_vm.title !== null ? _c('div', {
    staticClass: "el-message-box__header",
    attrs: {}
  }, [_c('div', {
    staticClass: "el-message-box__title",
    attrs: {}
  }, [_vm.icon && _vm.center ? _c('div', {
    "class": ['el-message-box__status', _vm.icon],
    attrs: {}
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm.showClose ? _c('button', {
    staticClass: "el-message-box__headerbtn",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function click($event) {
        _vm.handleAction(_vm.distinguishCancelAndClose ? 'close' : 'cancel');
      },
      "keydown": function keydown($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        _vm.handleAction(_vm.distinguishCancelAndClose ? 'close' : 'cancel');
      }
    }
  }, [_c('i', {
    staticClass: "el-message-box__close el-icon-close",
    attrs: {}
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-message-box__content",
    attrs: {}
  }, [_vm.showIcon && _vm.icon && !_vm.center && _vm.message !== '' ? _c('div', {
    "class": ['el-message-box__status', _vm.icon],
    attrs: {}
  }) : _vm._e(), _vm._v(" "), _vm.message !== '' ? _c('div', {
    staticClass: "el-message-box__message",
    attrs: {}
  }, [_vm._t("default", [!_vm.dangerouslyUseHTMLString ? _c('p', [_vm._v(_vm._s(_vm.message))]) : _c('p', {
    attrs: {},
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })], {})], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showInput,
      expression: "showInput"
    }],
    staticClass: "el-message-box__input",
    attrs: {}
  }, [_c('el-input', {
    ref: "input",
    attrs: {
      "type": _vm.inputType,
      "placeholder": _vm.inputPlaceholder
    },
    nativeOn: {
      "keydown": function keydown($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleInputEnter($event);
      }
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($v) {
        _vm.inputValue = $v;
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-message-box__errormsg",
    style: {
      visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden'
    },
    attrs: {}
  }, [_vm._v(_vm._s(_vm.editorErrorMessage))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "el-message-box__btns",
    attrs: {}
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showConfirmButton,
      expression: "showConfirmButton"
    }],
    ref: "confirm",
    "class": [_vm.confirmButtonClasses],
    attrs: {
      "loading": _vm.confirmButtonLoading,
      "round": _vm.roundButton
    },
    on: {
      "keydown": function keydown($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        _vm.handleAction('confirm', _vm.enterKey);
      }
    },
    nativeOn: {
      "click": function click($event) {
        _vm.handleAction('confirm');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.confirmButtonText || _vm.t('el.messagebox.confirm')) + "\n        ")]), _vm._v(" "), _vm.showCancelButton ? _c('el-button', {
    "class": [_vm.cancelButtonClasses],
    attrs: {
      "loading": _vm.cancelButtonLoading,
      "round": _vm.roundButton
    },
    on: {
      "keydown": function keydown($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        _vm.handleAction('cancel', _vm.enterKey);
      }
    },
    nativeOn: {
      "click": function click($event) {
        _vm.handleAction('cancel');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cancelButtonText || _vm.t('el.messagebox.cancel')) + "\n        ")]) : _vm._e()], 1)])])]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  mixins: [_popup["default"], _locale["default"]],
  props: {
    modal: {
      "default": true
    },
    lockScroll: {
      "default": true
    },
    showClose: {
      type: Boolean,
      "default": true
    },
    showIcon: {
      // 扩展隐藏不能状态图标
      type: Boolean,
      "default": true
    },
    closeOnClickModal: {
      "default": true
    },
    closeOnPressEscape: {
      "default": true
    },
    closeOnHashChange: {
      "default": true
    },
    center: {
      "default": false,
      type: Boolean
    },
    roundButton: {
      "default": false,
      type: Boolean
    },
    enterKey: {
      "default": true,
      type: Boolean
    }
  },
  components: {
    ElInput: _input["default"],
    ElButton: _button["default"]
  },
  computed: {
    icon: function icon() {
      var type = this.type,
          iconClass = this.iconClass;
      return iconClass || (type && typeMap[type] ? "el-icon-".concat(typeMap[type]) : '');
    },
    confirmButtonClasses: function confirmButtonClasses() {
      return "el-button--primary ".concat(this.confirmButtonClass);
    },
    cancelButtonClasses: function cancelButtonClasses() {
      return "".concat(this.cancelButtonClass);
    }
  },
  methods: {
    getSafeClose: function getSafeClose() {
      var _this = this;

      var currentId = this.uid;
      return function () {
        _this.$nextTick(function () {
          if (currentId === _this.uid) _this.doClose();
        });
      };
    },
    doClose: function doClose(action) {
      var _this2 = this;

      if (!this.visible) return;

      if (this.async && this.action && action === 'confirm') {
        this.confirmButtonLoading = true;
        var result = this.callback(this.action, this);

        if (result instanceof Promise) {
          // eslint-disable-line
          result.then(function () {
            _this2.confirmButtonLoading = false;

            _this2.executeClose();
          })["catch"](function () {
            _this2.confirmButtonLoading = false;
          });
        } else {
          this.confirmButtonLoading = false;
          this.executeClose();
        }
      } else {
        this.executeClose();
      }
    },
    executeClose: function executeClose() {
      var _this3 = this;

      this.visible = false;
      this._closing = true;
      this.onClose && this.onClose();
      messageBox.closeDialog(); // 解绑

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;
      this.doAfterClose();
      !this.async && setTimeout(function () {
        if (_this3.action) _this3.callback(_this3.action, _this3);
      });
    },
    handleWrapperClick: function handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
      }
    },
    handleInputEnter: function handleInputEnter() {
      if (this.inputType !== 'textarea') {
        return this.handleAction('confirm');
      }
    },
    handleAction: function handleAction(action, enterKey) {
      if (!_util.stopDoubleClickOnClickHandler.call(this)) {
        return;
      }

      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
        return;
      }

      if (enterKey === false) {
        return;
      }

      this.action = action;

      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose();
        this.beforeClose(action, this, this.close);
      } else {
        this.doClose(action);
      }
    },
    validate: function validate() {
      if (this.$type === 'prompt') {
        var inputPattern = this.inputPattern;

        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
          this.editorErrorMessage = this.inputErrorMessage || (0, _locale2.t)('el.messagebox.error');
          (0, _dom.addClass)(this.getInputElement(), 'invalid');
          return false;
        }

        var inputValidator = this.inputValidator;

        if (typeof inputValidator === 'function') {
          var validateResult = inputValidator(this.inputValue);

          if (validateResult === false) {
            this.editorErrorMessage = this.inputErrorMessage || (0, _locale2.t)('el.messagebox.error');
            (0, _dom.addClass)(this.getInputElement(), 'invalid');
            return false;
          }

          if (typeof validateResult === 'string') {
            this.editorErrorMessage = validateResult;
            (0, _dom.addClass)(this.getInputElement(), 'invalid');
            return false;
          }
        }
      }

      this.editorErrorMessage = '';
      (0, _dom.removeClass)(this.getInputElement(), 'invalid');
      return true;
    },
    getFirstFocus: function getFirstFocus() {
      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
      return btn || title;
    },
    getInputElement: function getInputElement() {
      var inputRefs = this.$refs.input.$refs;
      return inputRefs.input || inputRefs.textarea;
    }
  },
  watch: {
    inputValue: {
      immediate: true,
      handler: function handler(val) {
        var _this4 = this;

        this.$nextTick(function (_) {
          if (_this4.$type === 'prompt' && val !== null) {
            _this4.validate();
          }
        });
      }
    },
    visible: function visible(val) {
      var _this5 = this;

      if (val) {
        this.uid++; //  扩展 取消alert和confirm在打开窗口时对确认按钮的focus

        if (this.$type === 'alert' || this.$type === 'confirm') {
          this.$nextTick(function () {
            if (_this5.enterKey) {
              _this5.$refs.confirm.$el.focus();
            }
          });
        }

        this.focusAfterClosed = document.activeElement;
        messageBox = new _ariaDialog["default"](this.$el, this.focusAfterClosed, this.getFirstFocus());
      } // prompt


      if (this.$type !== 'prompt') return;

      if (val) {
        setTimeout(function () {
          if (_this5.$refs.input && _this5.$refs.input.$el) {
            _this5.getInputElement().focus();
          }
        }, 500);
      } else {
        this.editorErrorMessage = '';
        (0, _dom.removeClass)(this.getInputElement(), 'invalid');
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      if (_this6.closeOnHashChange) {
        window.addEventListener('hashchange', _this6.close);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close);
    }

    setTimeout(function () {
      messageBox.closeDialog();
    });
  },
  data: function data() {
    return {
      uid: 1,
      title: undefined,
      message: '',
      type: '',
      iconClass: '',
      customClass: '',
      showInput: false,
      inputValue: null,
      inputPlaceholder: '',
      inputType: 'text',
      inputPattern: null,
      inputValidator: null,
      inputErrorMessage: '',
      showConfirmButton: true,
      showCancelButton: false,
      action: '',
      confirmButtonText: '',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonClass: '',
      confirmButtonDisabled: false,
      cancelButtonClass: '',
      editorErrorMessage: null,
      callback: null,
      dangerouslyUseHTMLString: false,
      focusAfterClosed: null,
      isOnComposition: false,
      distinguishCancelAndClose: false,
      async: false
    };
  }
};
exports["default"] = _default;